export default function cloudinaryImageTransform(url, w = 150, h = 150) {
  url = url || '';
  const [urlStart = '', urlRest = ''] = url.split('/image/upload/');
  const transform = `/w_${w},h_${h},c_fill/`;
  const tumbnailUrl = urlStart + '/image/upload' + transform + urlRest;
  return tumbnailUrl;
}
